// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"a9942eeb","453":"239fa768"}[chunkId] + ".chunk.js";
};